(function () {
  if (window.customElements && customElements.get('sale-reminder-bar')) return;

  function countdownPhrase(target) {
    var diff = Math.max(0, target - Date.now());
    var s = Math.floor(diff / 1000);
    var dd = Math.floor(s / 86400);
    var hh = Math.floor((s % 86400) / 3600);
    var mm = Math.floor((s % 3600) / 60);
    var ss = s % 60;
    var p = function (n) { return String(n).padStart(2, '0'); };
    if (dd > 0) return dd + (dd === 1 ? ' day ' : ' days ') + hh + ' hrs ' + p(mm) + ' min';
    if (hh > 0) return hh + ' hrs ' + p(mm) + ' min ' + p(ss) + ' sec';
    return mm + ' min ' + p(ss) + ' sec';
  }

  /**
   * "2D 5H 57M 04S" — the short form used on the live bar.
   * Minutes and seconds are padded so the line doesn't jitter on every tick.
   */
  function compactPhrase(target) {
    var diff = Math.max(0, target - Date.now());
    var s = Math.floor(diff / 1000);
    var dd = Math.floor(s / 86400);
    var hh = Math.floor((s % 86400) / 3600);
    var mm = Math.floor((s % 3600) / 60);
    var ss = s % 60;
    var p = function (n) { return String(n).padStart(2, '0'); };
    return (dd > 0 ? dd + 'D ' : '') + hh + 'H ' + p(mm) + 'M ' + p(ss) + 'S';
  }

  class SaleReminderBar extends HTMLElement {
    connectedCallback() {
      if (this._booted) return;
      this._booted = true;

      var d = this.dataset;
      this.copy = {};
      try { this.copy = JSON.parse(this.querySelector('[data-eps-copy]').textContent); } catch (e) {}

      this.mode = d.mode || 'countdown';
      this.start = new Date(d.saleDate).getTime();
      this.end = new Date(d.saleEnd).getTime();
      if (isNaN(this.start)) this.start = 0;
      if (isNaN(this.end)) this.end = 0;
      this.popupCountdown = d.popupCountdown || 'end';

      this.endpoint = (d.endpoint || '').trim();
      this.minDigits = parseInt(d.phoneDigits, 10) || 10;
      this.remembers = d.rememberSubmitted === 'true';
      this.storageKey = 'eps-submitted-' + d.sectionId;

      this.overlay = this.querySelector('[data-eps-overlay]');
      this.panel = this.querySelector('[data-eps-panel]');
      this.form = this.querySelector('[data-eps-form]');
      this.nameEl = this.querySelector('[data-eps-name]');
      this.phoneEl = this.querySelector('[data-eps-phone]');
      this.hpEl = this.querySelector('[data-eps-hp]');
      this.submitEl = this.querySelector('[data-eps-submit]');
      this.errorEl = this.querySelector('[data-eps-error]');
      this.formState = this.querySelector('[data-eps-form-state]');
      this.doneState = this.querySelector('[data-eps-done]');
      this.successEl = this.querySelector('[data-eps-success-body]');
      this.liveRow = this.querySelector('[data-eps-live]');
      this.barPhraseEls = this.querySelectorAll('[data-eps-phrase]');
      this.compactEls = this.querySelectorAll('[data-eps-compact]');
      this.endsEls = this.querySelectorAll('[data-eps-ends]');
      this.popupPhraseEls = this.querySelectorAll('[data-eps-popup-phrase]');

      this.tick();
      this.timer = setInterval(this.tick.bind(this), 1000);

      var self = this;

      this.querySelectorAll('[data-eps-open]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.stopPropagation(); self.open(); });
      });

      if (d.barClickable === 'true') {
        var bar = this.querySelector('[data-eps-bar]');
        var link = this.querySelector('[data-eps-cta-link]');
        this.classList.add('eps--clickable');
        bar.addEventListener('click', function (e) {
          if (e.target.closest('a')) return;              // let real links behave
          if (self.classList.contains('eps--expired')) return;
          if (link) { window.location.href = link.href; return; }
          self.open();
        });
        bar.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          if (link) { window.location.href = link.href; } else { self.open(); }
        });
      }

      if (!this.overlay) return;   // form popup switched off

      this.querySelectorAll('[data-eps-close]').forEach(function (b) {
        b.addEventListener('click', function () { self.close(); });
      });

      this._onKey = function (e) { if (e.key === 'Escape') self.close(); };

      [this.nameEl, this.phoneEl].forEach(function (el) {
        el.addEventListener('input', function () { self.validate(); self.hideError(); });
      });
      this.phoneEl.addEventListener('input', function () {
        var digits = self.phoneEl.value.replace(/\D/g, '').slice(0, self.minDigits + 4);
        if (self.phoneEl.value !== digits) self.phoneEl.value = digits;
        self.validate();
      });

      this.form.addEventListener('submit', function (e) { e.preventDefault(); self.submit(); });

      // Already signed up on this device: relabel and pre-render the confirmation.
      var stored = this.remembers ? this.storedLead() : null;
      if (stored) {
        this.markAlreadyJoined();
        this.renderDone(stored);
      }

      var delay = parseInt(d.openOnLoad, 10);
      if (delay > 0 && !stored) {
        setTimeout(function () { self.open(); }, delay * 1000);
      }
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('keydown', this._onKey);
    }

    /* ---------------------------- local memory ---------------------------- */

    storedLead() {
      try {
        var v = window.localStorage.getItem(this.storageKey);
        if (!v) return null;
        if (v === '1') return {};            // written by an earlier version
        var parsed = JSON.parse(v);
        return (parsed && typeof parsed === 'object') ? parsed : {};
      } catch (e) { return null; }
    }

    remember(payload) {
      try {
        window.localStorage.setItem(this.storageKey, JSON.stringify({ phone: (payload && payload.phone) || '' }));
      } catch (e) {}
    }

    markAlreadyJoined() {
      var label = this.copy.alreadyLabel;
      if (!label) return;
      this.querySelectorAll('[data-eps-open]').forEach(function (b) { b.textContent = label; });
    }

    /* ----------------------------- countdowns ----------------------------- */

    startPhrase() { return countdownPhrase(this.start); }
    endPhrase() { return countdownPhrase(this.end); }

    popupPhrase() {
      if (this.popupCountdown === 'start') return this.startPhrase();
      if (this.popupCountdown === 'end') return this.endPhrase();
      return '';
    }

    tick() {
      // Only the countdown bar has an expiry state; the live bar is the expiry state.
      if (this.mode === 'countdown' && this.start > 0 && Date.now() >= this.start) {
        this.classList.add('eps--expired');
        if (this.liveRow) this.liveRow.hidden = false;
        if (this.dataset.hideWhenExpired === 'true') this.style.display = 'none';
      } else if (this.mode === 'countdown') {
        var text = this.startPhrase();
        this.barPhraseEls.forEach(function (el) { el.textContent = text; });
      }

      // Live-bar clock. Shown only while there is time left on it, so the bar
      // tidies itself up the moment the sale ends rather than reading "0H 0M".
      if (this.compactEls.length) {
        var running = this.end > 0 && Date.now() < this.end;
        if (running) {
          var compact = compactPhrase(this.end);
          this.compactEls.forEach(function (el) { el.textContent = compact; });
        }
        this.endsEls.forEach(function (el) { el.hidden = !running; });
      }

      var pp = this.popupPhrase();
      this.popupPhraseEls.forEach(function (el) { el.textContent = pp; });

      if (!this.overlay) return;
      if (!this.overlay.hidden && !this.doneState.hidden) this.paintDone();
    }

    /* ------------------------------- popup -------------------------------- */

    open() {
      if (!this.overlay) return;
      this.overlay.hidden = false;
      document.addEventListener('keydown', this._onKey);
      document.documentElement.style.overflow = 'hidden';
      var first = this.doneState.hidden ? this.nameEl : this.panel.querySelector('[data-eps-close]');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 60);
      this.dispatchEvent(new CustomEvent('eps:open', { bubbles: true }));
    }

    close() {
      this.overlay.hidden = true;
      document.removeEventListener('keydown', this._onKey);
      document.documentElement.style.overflow = '';
    }

    /* ------------------------------ validation ---------------------------- */

    digits() { return this.phoneEl.value.replace(/\D/g, ''); }

    isValid() {
      return this.nameEl.value.trim().length > 1 && this.digits().length >= this.minDigits;
    }

    validate() {
      this.submitEl.disabled = !this.isValid();
      return !this.submitEl.disabled;
    }

    showError(msg) { this.errorEl.textContent = msg; this.errorEl.hidden = false; }
    hideError() { this.errorEl.hidden = true; }

    /* ------------------------------- submit ------------------------------- */

    submit() {
      var self = this;
      if (this.hpEl && this.hpEl.value) { this.renderDone({}); return; }
      if (!this.nameEl.value.trim() || this.nameEl.value.trim().length < 2) { this.showError(this.copy.errorName); return; }
      if (this.digits().length < this.minDigits) { this.showError(this.copy.errorPhone); return; }

      var payload = {
        name: this.nameEl.value.trim(),
        phone: this.dataset.phonePrefix + this.digits(),
        phone_local: this.digits(),
        tags: this.dataset.tags,
        source: this.dataset.source,
        page: window.location.pathname
      };

      this.submitEl.disabled = true;
      this.submitEl.textContent = this.copy.submitting || '...';
      this.hideError();

      if (!this.endpoint) {
        console.warn('[sale-reminder-bar] No endpoint configured. Lead payload:', payload);
        this.finish(payload);
        return;
      }

      fetch(this.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json().catch(function () { return { ok: r.ok }; }).then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok || (res.body && res.body.ok === false)) {
            throw new Error((res.body && res.body.error) || 'failed');
          }
          self.finish(payload);
        })
        .catch(function (err) {
          console.error('[sale-reminder-bar]', err);
          self.submitEl.disabled = false;
          self.submitEl.textContent = self.copy.submitLabel;
          self.showError(self.copy.errorGeneric);
        });
    }

    finish(payload) {
      this.remember(payload);
      this.markAlreadyJoined();
      this.renderDone(payload);
      this.dispatchEvent(new CustomEvent('eps:submitted', { bubbles: true, detail: payload }));
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        try { window.Shopify.analytics.publish('sale_reminder_signup', { source: payload.source }); } catch (e) {}
      }
    }

    /* --------------------------- confirmation ----------------------------- */

    renderDone(payload) {
      this._donePhone = (payload && payload.phone) || '';
      this.paintDone();
      this.formState.hidden = true;
      this.doneState.hidden = false;
    }

    paintDone() {
      if (!this.successEl) return;
      var phone = this._donePhone
        ? ' <strong>' + this._donePhone.replace(/[<>&]/g, '') + '</strong>'
        : ' you';
      this.successEl.innerHTML = (this.copy.successBody || '')
        .replace(/\s*\[phone\]|\s*\{\{\s*phone\s*\}\}/g, phone)
        .replace(/\[phrase\]|\{\{\s*phrase\s*\}\}/g, this.popupPhrase());
    }
  }

  customElements.define('sale-reminder-bar', SaleReminderBar);
})();
